<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Sales Imports</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="accent" @click.native="importDialog = true" text>
              <v-icon>mdi-plus</v-icon>New Sale Import
            </v-btn>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-col cols="12" class="subtitle-2 text--primary">
          <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
          <!-- start of table -->
          <v-data-table :mobile-breakpoint="0" :items-per-page="1000" :headers="headers" :items="pendingSales"
            :search="search">

              <!-- name template -->
              <template v-slot:item.name="{ item }">
              <v-btn :to="`/uploaded-invoices/${item.id}`" color="primary" text>
                <v-icon left>mdi-eye</v-icon> {{ item.name }}
              </v-btn>
            </template>
            <!-- end -->

            <!-- action template -->
            <template v-slot:item.action="{ item }">
              <v-btn v-if="item.status != 1" :loading="loader" @click="processExcel(item.id)" color="accent" text>
                <v-icon left>mdi-progress-clock</v-icon>Process Excel
              </v-btn>
            </template>
            <!-- end -->

              <!-- action template -->
              <template v-slot:item.total_quantity="{ item }">
              <span> {{  item.total_quantity.toLocaleString() }}</span>
            </template>
            <!-- end -->

             <!-- action template -->
             <template v-slot:item.doc_total="{ item }">
              <span> {{  item.doc_total | currency }}</span>
            </template>
            <!-- end -->

            <!-- action template -->
            <template v-slot:item.status="{ item }">
              <span v-if="item.status == 1">Successfully Uploaded</span>
              <span v-else>Pending</span>
            </template>
            <!-- end -->

            <!-- action template -->
            <template v-slot:item.view="{ item }">
              <!-- <a
                target="_blank"
                :href="`http://localhost:8300/preview-excel-data/${item.id}`"
              >Export Excel</a> -->
              <v-btn text color="green" @click="viewExcel(item.id)"><v-icon left>mdi-file-excel</v-icon>View
                Excel</v-btn>
            </template>
            <!-- end -->


            <!-- action template -->
            <template v-slot:item.error="{ item }">
              <span style="color: green" v-if="item.status == 1">{{ item.error }}</span>
              <span style="color: red" v-if="item.status == 0">{{ item.error }}</span>
            </template>
            <!-- end -->

            <!-- action template -->
            <template v-slot:item.doc_date="{ item }">{{ item.doc_date | date }}</template>
            <!-- end -->

            <!-- action template -->
            <template v-slot:item.deleteDoc="{ item }">
              <v-btn v-if="item.status != 1" color="red" @click="openDeleteModal(item)" text icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <!-- end -->
          </v-data-table>
          <!-- end -->
        </v-col>

        <!--  Products summary dialog -->
        <v-dialog v-model="importDialog" max-width="850px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title>Upload Sales</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="importDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-autocomplete autocomplete="off" dense outlined v-model="CardCode" :items="customers"
                      label="Customer" item-text="Name" item-value="id"
                      :search-input.sync="searchCustomers"></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field v-model="title" label="Title" outlined dense></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
                  </v-col>

                  <v-col cols="6">
                    <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
                      dense></v-file-input>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="primary" @click="uploadExcel" :loading="loader" :disabled="loader">
                      <v-icon left>mdi-upload</v-icon>Upload Sales Excel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of products summary modal-->

        <!-- product dialog modal-->
        <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="red" dark flat>
              <v-toolbar-title>Delete Document</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">Are you sure you want to delete this document?</v-col>
                  <v-col cols="12">
                    <span style="font-size: 20px">{{ docItem.name }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="red" dark :loading="loader" @click="deleteDoc">Yes, Delete</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- <iframe src="https://docs.google.com/spreadsheets/d/1KMaIYgcJ8QxZcrUjWd7mun3LKHYglcewo1pgUy-uJn8/edit?gid=3917878#gid=3917878&amp;single=true&amp;widget=true&amp;headers=false" width="100%" height="800px"></iframe> -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
  </v-container>
</template>

<script>
// import * as XLSX from 'xlsx';
import { http, host } from "@/common/index";
export default {
  data() {
    return {
      blobUrl: null,
      search: null,
      CardCode: null,
      deleteDialog: false,
      searchCustomers: null,
      customers: [],
      docItem: {},
      record: {},
      loader: false,
      importDialog: false,
      pageItems: 2000,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      summaryData: [],
      excelFile: null,
      ObjType: 14,
      title: null,
      objtypes: [
        {
          Name: "Sales",
          id: 14
        },
        {
          Name: "Product List",
          id: 21
        }
      ],
      headers: [
        { text: "Sales Title", value: "name" },
        { text: "Date", value: "doc_date" },
        { text: "Total Quantity", value: "total_quantity" },
        // { text: "Total Value", value: "doc_total" },
        { text: "Message", value: "error" },
        { text: "Status", value: "status" },
       // { text: "View", value: "view" },
        { text: "Action", value: "action" },
        { text: "Delete", value: "deleteDoc" }
      ],
      pendingSales: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    queryCustomers(searchText) {
      console.log(searchText);
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openDeleteModal(data) {
      this.docItem = data;
      this.deleteDialog = true;
    },
    deleteDoc() {
      const url = `/delete-sale-document/${this.docItem.id}`;
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          console.log(res, " upload response");
          if (res.ResultCode == 1200) {
            self.loader = false;
           self.getRecords();
            self.deleteDialog = false;
          } else {
            self.loader = false;
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          self.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    uploadExcel() {
      if (this.date == null || this.title == null) {
        this.$refs.snackbar.show("Please fill all fields", "red");
      } else {
        const data = new FormData();
        data.append("documentData", this.excelFile);
        data.append("DocDate", this.date);
        data.append("CardCode", this.CardCode);
        data.append("Name", this.title);
        data.append("ObjType", this.ObjType);
        // send request
        this.loader = true;
        const url = "/import-sales";
        const self = this;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show(
                "Products imported successfully",
                "green"
              );
              self.loader = false;
              self.excelFile = null;
              self.importDialog = false;
            } else {
              self.loader = false;
              self.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          })
          .finally(() => {
            self.getRecords();
          });
        // end
      }
    },
    getRecords() {
      const self = this;
      this.$store.commit("loader", true);
      const url = `/file-upload-list`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.pendingSales = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    processExcel(id) {
      const url = `/process-imported-sales/${id}`;
      const self = this;
      this.loader = true;
      const data = {};
      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getRecords();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.getRecords();
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
          self.getRecords();
        });
    },
    viewExcel(id) {
      console.log('view excel ', id)
      const self = this;
      const url = `/preview-excel-data/${id}`; // Ensure this endpoint returns a PDF blob
      const apiUrl = `${host}${url}`;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        console.log(response, 'response');
        // const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // Assuming PDF format
        // var fileUrl = URL.createObjectURL(blob)
        var fileUrl = `https://docs.google.com/spreadsheets/d/1KMaIYgcJ8QxZcrUjWd7mun3LKHYglcewo1pgUy-uJn8/edit?gid=3917878#gid=3917878&amp;single=true&amp;widget=true&amp;headers=false`;

        self.$refs.pdfPreview.show(fileUrl);
      });
    }
    // viewExcel(id) {
    //   const url = `/preview-excel-data/${id}`;
    //   const apiUrl = `${host}${url}`;
    //   const self = this;
    //   http.get(apiUrl, { responseType: "blob" }).then(response => {
    //     const blob = new Blob([response.data], { type: "application/pdf" });
    //     var fileUrl = URL.createObjectURL(blob);
    //     self.$refs.pdfPreview.show(fileUrl);
    //   });
    // }
  },
  created() {
    this.getRecords();
  }
};
</script>

<style lang="scss" scoped></style>